module.exports = {"printLink":"Print all guardian information"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/protege-all-info.json
// module id = YNr6
// module chunks = 1